import {
  ShoppingCart as ShoppingCartIcon,
} from '../icons';
import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useCart } from '../../contexts/CartContext';
import { useCurrencyFormatter } from '../../contexts/CurrencyContext';
import { usePublicTheme } from '../../contexts/PublicThemeContext';
import { getHoverColor } from '../../utils/colorUtils';

const FixedCartWidget = ({ onClick }) => {
  const { totalItems, orderBreakdown } = useCart();
  const { formatCurrency } = useCurrencyFormatter();
  const { primaryColor } = usePublicTheme();

  // Don't show the widget if cart is empty
  if (totalItems === 0) {
    return null;
  }

  const itemText = totalItems === 1 ? 'Item' : 'Items';

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 16, md: 28 },
        right: { xs: 16, md: 28 },
        left: { xs: 16, md: 'auto' },
        zIndex: 1000,
      }}
    >
      <Button
        variant="contained"
        onClick={onClick}
        startIcon={<ShoppingCartIcon sx={{ fontSize: { xs: 20, md: 26 } }} />}
        sx={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: { xs: 4, md: 5 },
          px: { xs: 2.5, md: 5 },
          py: { xs: 1.5, md: 2.5 },
          background: `linear-gradient(135deg, ${primaryColor} 0%, ${getHoverColor(primaryColor, 'darken', 15)} 100%)`,
          boxShadow: `0 12px 40px ${primaryColor}70, 0 6px 16px rgba(0, 0, 0, 0.25)`,
          fontSize: { xs: '0.875rem', md: '1.1rem' },
          fontWeight: 800,
          textTransform: 'none',
          width: { xs: '100%', md: 'auto' },
          minWidth: { xs: 0, md: '320px' },
          border: 'none',
          backdropFilter: 'blur(15px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-5px) scale(1.04)',
            background: `linear-gradient(135deg, ${getHoverColor(primaryColor, 'darken', 10)} 0%, ${getHoverColor(primaryColor, 'darken', 25)} 100%)`,
            boxShadow: `0 20px 55px ${primaryColor}80, 0 10px 25px rgba(0, 0, 0, 0.35)`,
          },
          '&:active': {
            transform: 'translateY(-3px) scale(1.02)',
          },
        }}
      >
        <Typography
          variant="body1"
          component="span"
          sx={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 'inherit',
            fontWeight: 'inherit',
            whiteSpace: 'nowrap',
            letterSpacing: '-0.01em',
            display: { xs: 'none', sm: 'inline' },
          }}
        >
          Your Cart - {totalItems} {itemText} • {formatCurrency(orderBreakdown.total)}
        </Typography>
        <Typography
          variant="body1"
          component="span"
          sx={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 'inherit',
            fontWeight: 'inherit',
            whiteSpace: 'nowrap',
            letterSpacing: '-0.01em',
            display: { xs: 'inline', sm: 'none' },
          }}
        >
          {totalItems} {itemText} • {formatCurrency(orderBreakdown.total)}
        </Typography>
      </Button>
    </Box>
  );
};

export default FixedCartWidget;
